import { cloneDeep, keyBy } from "lodash";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { calculateTeamAgentIds } from "helpers/team";
import {
  CRUDAction,
  IEntityDeleteSuccess,
  IEntityFetchCollectionSuccess,
  IEntityFetchSuccess,
  RequestAction,
} from "store/entities/actions";
import { IEntityCollectionState } from "store/entities/reducer";

import { TEAM, TeamAction, TeamActionsNames } from "./actions";
import {
  ISyncDefaultTeamIdPayload,
  ISyncDeletedAgentPayload,
  ISyncTeamAgentsPayload,
  ISyncUpdatedAgentPayload,
  ITeam,
} from "./interfaces";

const initialState = {};

export const teamsReducer = (
  state: IEntityCollectionState<ITeam> = initialState,
  action: TeamAction
): IEntityCollectionState<ITeam> => {
  switch (action.type) {
    case TEAM[CRUDAction.FETCH_SINGLE][RequestAction.SUCCESS]:
    case TEAM[CRUDAction.CREATE][RequestAction.SUCCESS]:
    case TEAM[CRUDAction.UPDATE][RequestAction.SUCCESS]:
    case TEAM.UPDATE_NOTIFICATIONS[RequestAction.SUCCESS]: {
      const { value: team } = action.payload as IEntityFetchSuccess<ITeam>;
      return {
        ...state,
        [team.id]: team,
      };
    }

    case TEAM[CRUDAction.FETCH_COLLECTION][RequestAction.SUCCESS]: {
      const { values } = action.payload as IEntityFetchCollectionSuccess<ITeam>;
      return keyBy(values, v => v.id);
    }

    case TEAM[CRUDAction.DELETE][RequestAction.SUCCESS]:
    case TeamActionsNames.SYNC_DELETE: {
      const { id } = action.payload as IEntityDeleteSuccess;
      const newState = { ...state };
      // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
      delete newState[id];
      return newState;
    }

    case TeamActionsNames.SYNC_UPDATED_AGENT: {
      const { agent } = action.payload as ISyncUpdatedAgentPayload;
      const newState = cloneDeep(state);
      Object.keys(newState).forEach((teamId: string) => {
        const team = newState[teamId];
        if (agent.teamIds.includes(teamId)) {
          if (!team.agentIds.includes(agent.id)) {
            const updatedTeam = { ...newState[teamId] };
            updatedTeam.agentIds.push(agent.id);
            newState[teamId] = updatedTeam;
          }
        } else if (team.agentIds.includes(agent.id)) {
          const updatedTeam = { ...newState[teamId] };
          updatedTeam.agentIds = updatedTeam.agentIds.filter(teamAgentId => teamAgentId !== agent.id);
          newState[teamId] = updatedTeam;
        }
      });
      return newState;
    }

    case TeamActionsNames.SYNC_DELETED_AGENT: {
      const { agentId } = action.payload as ISyncDeletedAgentPayload;
      const newState = { ...state };
      Object.keys(newState).forEach((teamId: string) => {
        const updatedTeam = { ...newState[teamId] };
        updatedTeam.agentIds = updatedTeam.agentIds.filter(teamAgentId => teamAgentId !== agentId);
        newState[teamId] = updatedTeam;
      });
      return newState;
    }

    case TeamActionsNames.SYNC_CREATED_AGENTS:
    case TeamActionsNames.SYNC_AGENTS: {
      const { agents } = action.payload as ISyncTeamAgentsPayload;
      const newState = { ...state };
      Object.keys(newState).forEach((teamId: string) => {
        const updatedTeam = { ...newState[teamId] };
        updatedTeam.agentIds = calculateTeamAgentIds(teamId, agents);
        newState[teamId] = updatedTeam;
      });
      return newState;
    }

    case TeamActionsNames.SYNC_DEFAULT_TEAM_ID: {
      const { defaultTeamId } = action.payload as ISyncDefaultTeamIdPayload;
      const currentDefaultTeamId = Object.keys(state).find((teamId: string) => state[teamId].isDefault);
      if (currentDefaultTeamId !== defaultTeamId) {
        // make sure the new default team already exists in the collection
        // (default team info may come earlier then collection update)
        const newDefaultTeamExists = state[defaultTeamId] !== undefined;
        if (newDefaultTeamExists) {
          const newState = { ...state };
          // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
          newState[currentDefaultTeamId] = {
            // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
            ...newState[currentDefaultTeamId],
            isDefault: false,
          };
          newState[defaultTeamId] = {
            ...newState[defaultTeamId],
            isDefault: true,
          };
          return newState;
        }
      }

      return state;
    }

    default:
      return state;
  }
};
